import { cn } from '../../../lib/utils';

function PawIcon({ className }: { className?: string }) {
  return (
    <svg
      className={cn('size-3.5 shrink-0 text-primary-foreground', className)}
      viewBox='0 0 24 24'
      fill='currentColor'
      aria-hidden
    >
      <path d='M12 10.5c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm-5.25 4.5c-.83 0-1.5-.67-1.5-1.5 0-1.66 1.34-3 3-3s3 1.34 3 3c0 .83-.67 1.5-1.5 1.5h-3zm10.5 0c-.83 0-1.5-.67-1.5-1.5 0-1.66 1.34-3 3-3s3 1.34 3 3c0 .83-.67 1.5-1.5 1.5h-3zm-5.25 3c-1.66 0-3-1.34-3-3 0-.83.67-1.5 1.5-1.5h3c.83 0 1.5.67 1.5 1.5 0 1.66-1.34 3-3 3z' />
    </svg>
  );
}

export type MatchPercentBadgeProps = {
  matchPercent: number;
  className?: string;
};

export function MatchPercentBadge({
  matchPercent,
  className,
}: MatchPercentBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full bg-primary-600 px-2.5 py-1 text-xs font-semibold tabular-nums text-primary-foreground shadow-sm',
        className,
      )}
    >
      <PawIcon />
      {matchPercent}% Match
    </span>
  );
}
